document.addEventListener('click', function (event) {
  const button = event.target.closest('.brand-size-row__cart-button');

  if (!button || button.disabled || button.classList.contains('is-disabled')) return;

  const variantId = button.dataset.variantId;
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  if (!variantId) return;

  button.disabled = true;
  button.classList.add('is-loading');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', 1);

  if (cart) {
    formData.append(
      'sections',
      cart.getSectionsToRender().map(function (section) {
        return section.id;
      })
    );
    formData.append('sections_url', window.location.pathname);

    if (typeof cart.setActiveElement === 'function') {
      cart.setActiveElement(document.activeElement);
    }
  }

  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then(function (response) {
      return response.json();
    })
    .then(function (response) {
      if (response.status) {
        alert(response.description || 'カートに追加できませんでした。');
        return;
      }

      if (!cart) {
        window.location = window.routes.cart_url;
        return;
      }

      cart.renderContents(response);
    })
    .catch(function (error) {
      console.error(error);
    })
    .finally(function () {
      button.disabled = false;
      button.classList.remove('is-loading');
      if (cart && cart.classList.contains('is-empty')) {
        cart.classList.remove('is-empty');
      }
    });
});

/* ==============================
  Swym：バリエーション別お気に入り
============================== */

function getBrandWishlistButtons() {
  return document.querySelectorAll(
    '.brand-size-row__favorite-button, [data-brand-quick-add-wishlist]'
  );
}

function updateBrandWishlistButton(button, isAdded) {
  button.classList.toggle('is-added', isAdded);
  button.setAttribute('aria-pressed', isAdded ? 'true' : 'false');

  const icon = button.querySelector('[aria-hidden="true"]');

  if (icon) {
    icon.textContent = isAdded ? '♥' : '♡';
  } else {
    button.textContent = isAdded ? '♥' : '♡';
  }
}

function runWithSwym(callback) {
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  window.SwymCallbacks.push(callback);
}

document.addEventListener('click', function (event) {
  const button = event.target.closest(
    '.brand-size-row__favorite-button, [data-brand-quick-add-wishlist]'
  );

  if (!button) return;

  event.preventDefault();
  event.stopPropagation();

  const productId = Number(button.dataset.productId);
  const variantId = Number(button.dataset.variantId);
  const productUrl = button.dataset.productUrl;

  if (!productId || !variantId || !productUrl) return;

  const productData = {
    epi: variantId,
    empi: productId,
    du: productUrl
  };

  button.disabled = true;

  runWithSwym(function (swat) {
    const isAdded = button.classList.contains('is-added');

    if (isAdded) {
      swat.removeFromWishList(
        productData,
        function () {
          updateBrandWishlistButton(button, false);
          syncBrandWishlistButtons(productId, variantId, false);
          button.disabled = false;
        },
        function () {
          button.disabled = false;
          alert('お気に入りを解除できませんでした。');
        }
      );
    } else {
      swat.addToWishList(
        productData,
        function () {
          updateBrandWishlistButton(button, true);
          syncBrandWishlistButtons(productId, variantId, true);
          button.disabled = false;
        },
        function () {
          button.disabled = false;
          alert('お気に入りに追加できませんでした。');
        }
      );
    }
  });
});

function syncBrandWishlistButtons(productId, variantId, isAdded) {
  getBrandWishlistButtons().forEach(function (button) {
    const buttonProductId = Number(button.dataset.productId);
    const buttonVariantId = Number(button.dataset.variantId);

    if (
      buttonProductId === Number(productId) &&
      buttonVariantId === Number(variantId)
    ) {
      updateBrandWishlistButton(button, isAdded);
    }
  });
}

function markBrandWishlistButtons() {
  const buttons = getBrandWishlistButtons();

  if (!buttons.length) return;

  runWithSwym(function (swat) {
    swat.fetch(
      function (products) {
        buttons.forEach(function (button) {
          const productId = Number(button.dataset.productId);
          const variantId = Number(button.dataset.variantId);

          const isAdded = products.some(function (item) {
            return (
              Number(item.empi) === productId &&
              Number(item.epi) === variantId
            );
          });

          updateBrandWishlistButton(button, isAdded);
        });
      },
      function () {
        console.warn('お気に入り状態を取得できませんでした。');
      }
    );
  });
}

document.addEventListener('DOMContentLoaded', markBrandWishlistButtons);

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.brand-product-accordion__item').forEach(function (details) {
    const summary = details.querySelector('.brand-product-accordion__summary');
    const content = details.querySelector('.brand-product-accordion__content');

    if (!summary || !content) return;

    if (details.open) {
      content.style.maxHeight = content.scrollHeight + 'px';
    } else {
      content.style.maxHeight = '0px';
    }

    summary.addEventListener('click', function (event) {
      event.preventDefault();

      if (details.open) {
        content.style.maxHeight = content.scrollHeight + 'px';

        requestAnimationFrame(function () {
          content.style.maxHeight = '0px';
        });

        setTimeout(function () {
          details.open = false;
        }, 300);
      } else {
        details.open = true;

        requestAnimationFrame(function () {
          content.style.maxHeight = content.scrollHeight + 'px';
        });
      }
    });
  });
});

function moveMattrzPointBox() {
  const target = document.querySelector('#brand-product-point-box');
  const mattrz = document.querySelector('#mattrz-cx-campaign-element-campaign-137901');

  if (!target || !mattrz) return false;

  if (target.contains(mattrz)) return true;

  target.appendChild(mattrz);
  mattrz.style.display = '';

  return true;
}

document.addEventListener('DOMContentLoaded', function () {
  if (moveMattrzPointBox()) return;

  const observer = new MutationObserver(function () {
    if (moveMattrzPointBox()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

document.addEventListener('click', function (event) {
  const button = event.target.closest(
    '.brand-size-row__cart-button.is-disabled'
  );

  if (!button) return;

  event.preventDefault();

  const variantId = String(button.dataset.variantId || '');

  if (!variantId) return;

  /*
   * カスタムサイズ行で押したバリエーションを、
   * Shopifyの商品フォーム側にも反映する
   */
  const productInfo =
    button.closest('product-info') ||
    document.querySelector('product-info');

  const productForm =
    productInfo?.querySelector('form[action*="/cart/add"]') ||
    document.querySelector('form[action*="/cart/add"]');

  const variantInput = productForm?.querySelector(
    'input[name="id"], select[name="id"]'
  );

  if (variantInput) {
    variantInput.value = variantId;

    variantInput.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );
  }

  /*
   * BISアプリ側のdata-variant-id更新を少し待ってからクリック
   */
  let attempts = 0;
  const maxAttempts = 20;

  const openRestockModal = window.setInterval(function () {
    attempts += 1;

    const bisButton = document.querySelector(
      `.bis-button.BIS_trigger[data-variant-id="${variantId}"]`
    );

    if (bisButton) {
      window.clearInterval(openRestockModal);
      bisButton.click();
      return;
    }

    if (attempts >= maxAttempts) {
      window.clearInterval(openRestockModal);
      console.warn(
        '対象バリエーションの再入荷ボタンが見つかりませんでした:',
        variantId
      );
    }
  }, 100);
});

// SP時：モデル着用アイテムをスタッフコーディネート前へ移動
document.addEventListener('DOMContentLoaded', function () {
  const modelItems = document.querySelector('.brand-model-items');
  const staffCoordinate = document.querySelector('.brand-staff-coordinate');

  if (!modelItems || !staffCoordinate) return;

  const originalParent = modelItems.parentNode;
  const originalNextSibling = modelItems.nextSibling;
  const mediaQuery = window.matchMedia('(max-width: 768px)');

  function moveModelItems() {
    if (mediaQuery.matches) {
      if (modelItems.nextElementSibling !== staffCoordinate) {
        staffCoordinate.parentNode.insertBefore(modelItems, staffCoordinate);
      }
    } else {
      if (originalNextSibling) {
        originalParent.insertBefore(modelItems, originalNextSibling);
      } else {
        originalParent.appendChild(modelItems);
      }
    }
  }

  moveModelItems();
  mediaQuery.addEventListener('change', moveModelItems);
});

/* ==============================
  カラーサムネイル → メイン画像切り替え
============================== */

document.addEventListener('click', function (event) {
  const button = event.target.closest('.brand-color-group__image-button');

  if (!button) return;

  event.preventDefault();

  const mediaId = button.dataset.brandColorMediaId;

  if (!mediaId) return;

  const productInfo =
    button.closest('product-info') ||
    document.querySelector('product-info');

  const mediaGallery =
    productInfo?.querySelector('media-gallery') ||
    document.querySelector('media-gallery');

  if (!mediaGallery) return;

  /*
   * section IDをこちらで組み立てず、
   * 実際にDOMに存在するdata-media-idを探す
   */
  const targetMedia = mediaGallery.querySelector(
    `[data-media-id$="-${mediaId}"]`
  );

  if (!targetMedia) {
    console.warn('対象の商品画像が見つかりません:', mediaId);
    return;
  }

  const fullMediaId = targetMedia.dataset.mediaId;

  if (typeof mediaGallery.setActiveMedia === 'function') {
    mediaGallery.setActiveMedia(fullMediaId, false);
  }
});